module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "right-visible": false
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('DateRangeList', {
    attrs: {
      "default": "Last month"
    },
    on: {
      "change": _vm.loadData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "disabled": !_vm.admin,
      "color": "primary",
      "label": "Just my invoices"
    },
    model: {
      value: (_vm.currentUserOnly),
      callback: function($$v) {
        _vm.currentUserOnly = $$v
      },
      expression: "currentUserOnly"
    }
  }), _vm._v(" "), (_vm.admin) ? _c('v-select', {
    attrs: {
      "items": ['Client Invoices', 'Processor Invoices', 'All Invoices'],
      "label": "Filter Invoices"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": _vm.areAllInvoicesSelected,
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.selectAllInvoices
          }
        }, on), [_c('v-icon', [_vm._v("mdi-select")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Select All Invoices")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": !_vm.areInvoicesSelected,
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.clearSelectedInvoices
          }
        }, on), [_c('v-icon', [_vm._v("mdi-select-off")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Clear Selections")])]), _vm._v(" "), _c('SplitButton', {
    staticClass: "full-width",
    attrs: {
      "text": _vm.pluralise('Send', this.selectedInvoiceKeys.length, 'Invoice', 'Invoices'),
      "disabled": !_vm.areInvoicesSelected,
      "menus": [{
        text: 'To Client'
      }, {
        text: 'To Processor'
      }, {
        text: 'To Both'
      }, {
        text: 'Send Reminder'
      }, {
        text: 'To Bookkeeper'
      }]
    },
    on: {
      "click": _vm.emailSelectedInvoices
    }
  }), _vm._v(" "), _c('SplitButton', {
    staticClass: "full-width",
    attrs: {
      "menu-only": "",
      "text": _vm.pluralise('Mark', this.selectedInvoiceKeys.length, 'Invoice', 'Invoices'),
      "disabled": !_vm.areInvoicesSelected,
      "menus": [{
        text: 'Sent'
      }, {
        text: 'Paid'
      }, {
        text: 'Outstanding'
      }]
    },
    on: {
      "click": _vm.markInvoices
    }
  }), _vm._v(" "), (_vm.admin) ? _c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "disabled": !_vm.areInvoicesSelected
    },
    on: {
      "click": _vm.makeInsightBills
    }
  }, [_vm._v("Make Insight Bills")]) : _vm._e()], 1), _vm._v(" "), _c('SectionLayout', {
    attrs: {
      "section": _vm.leftPageSection
    }
  })], 1), _vm._v(" "), _vm._l((_vm.billingTableGrouped), function(invoice, invoiceKey) {
    return _c('div', {
      key: invoiceKey,
      ref: 'invoice-' + invoiceKey,
      refInFor: true,
      staticClass: "pa-3 elevation-1 ma-3 white-background invoice-hoverable",
      class: {
        'blue-hilight': _vm.isInvoiceSelected(invoiceKey)
      },
      staticStyle: {
        "overflow": "auto",
        "border": "solid 1px transparent",
        "max-width": "700px"
      },
      on: {
        "click": function($event) {
          return _vm.toggleInvoiceSelection(invoiceKey)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "30px"
      }
    }, [_vm._v("INVOICE "), _c('span', {
      staticStyle: {
        "color": "#bbb"
      }
    }, [_vm._v(_vm._s(_vm.getInvoiceId(invoice)))])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("To:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice[0].payer.firstName) + " " + _vm._s(invoice[0].payer.lastName) + " (" + _vm._s(invoice[0].payer.email) + ")")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("From:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice[0].recipient.firstName) + " " + _vm._s(invoice[0].recipient.lastName))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("ABN:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getProcessorDetails(invoice[0].recipient.email, 'abn')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("Account:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getProcessorDetails(invoice[0].recipient.email, 'account')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
      attrs: {
        "width": "100%"
      }
    }, _vm._l((invoice), function(charge) {
      return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(_vm._f("date")(charge.charge_date)) + "\n                    ")]), _vm._v(" "), _c('div', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('td', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(charge.client) + "\n                        ")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deleteCharge(charge)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete Charge")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(charge.comment) + "\n                    ")]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v("\n                        " + _vm._s(charge.amount) + " "), (charge.status) ? _c('strong', [_vm._v("*** " + _vm._s(charge.status) + " ***")]) : _vm._e()])])
    }), 0), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right",
        "padding": "3px",
        "width": "99%"
      }
    }, [_vm._v("Total:")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.invoiceTotal(invoice))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right",
        "padding": "3px"
      }
    }, [_vm._v("+GST: ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("cents")((_vm.invoiceTotal(invoice) * 0.1))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right",
        "padding": "3px"
      }
    }, [_vm._v("Amount Payable:")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("cents")((_vm.invoiceTotal(invoice) * 1.1))))])])])]), _vm._v(" "), _c('small', [_vm._v("* Direct debit is on " + _vm._s(_vm._f("shortDate")(_vm.nextTwentieth)) + ". Manual payments due by the 15th.")])])
  }), _vm._v(" "), _c('template', {
    slot: "right"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e439098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/BillingOld.vue
// module id = 2628
// module chunks = 1